// @flow
import { connect } from 'react-redux';
import type { State } from '../../../types';
import Options from '../Options';
import type { Props } from '../Options';

const mapStateToProps = (state: State) => {
    return {

    }
};

export default connect<Props, _, _, _, _, _>(mapStateToProps)(Options);